import { api } from '../services/api';

// Legacy browser Maps JS loader may have left a script tag; remove it (server proxy only now).
if (typeof document !== 'undefined') {
  document.querySelectorAll('script[data-google-places-sdk]').forEach((el) => el.remove());
}

function friendlyPlacesError(err) {
  const msg = String(
    err?.response?.data?.data?.reason ||
      err?.response?.data?.message ||
      err?.message ||
      err ||
      ''
  );

  if (
    msg.includes('referer restrictions') ||
    msg.includes('referer restriction') ||
    msg.includes('not authorized to use this API key')
  ) {
    return 'Server Google API key cannot use website restrictions. In Google Cloud create a server key with Application restrictions = None (or IP only), enable Places API, and set GOOGLE_PLACES_API_KEY in server/.env.';
  }
  if (msg.includes('Internal server error')) {
    return 'Address lookup failed on the server. Check GOOGLE_PLACES_API_KEY in server/.env (must be a server key without website restrictions).';
  }
  if (msg.includes('REQUEST_DENIED') || msg.includes('PERMISSION_DENIED')) {
    return 'Google Places access denied — enable Places API on your server API key in Google Cloud Console.';
  }
  if (msg.includes('not configured')) {
    return 'Address autocomplete is not configured on the server (GOOGLE_PLACES_API_KEY missing).';
  }
  if (msg.includes('401') || msg.includes('Unauthorized')) {
    return 'Sign in to use address suggestions.';
  }
  return msg || 'Address suggestions unavailable — type your full address manually.';
}

export function getGooglePlacesSetupHint(error) {
  return friendlyPlacesError(error);
}

/** Autocomplete is server-backed; always attempt when logged in. */
export function isBrowserPlacesConfigured() {
  return true;
}

export function preloadGooglePlaces() {
  return Promise.resolve();
}

export async function autocompleteUsAddresses(query) {
  const input = String(query || '').trim();
  if (input.length < 3) {
    return { enabled: false, suggestions: [] };
  }

  const response = await api.get('/address/autocomplete', { params: { q: input } });
  const payload = response.data?.data || {};

  if (payload.enabled === false) {
    const reason = payload.reason || 'Address autocomplete is not configured on the server.';
    throw new Error(reason);
  }

  return {
    enabled: true,
    suggestions: payload.suggestions || [],
  };
}

export async function resolvePlaceAddress(placeId) {
  const response = await api.get('/address/details', {
    params: { placeId: String(placeId || '').trim() },
  });
  return response.data?.data || {};
}

export async function smokeTestGooglePlaces(query = '6824 Highway') {
  try {
    const { suggestions } = await autocompleteUsAddresses(query);
    if (!suggestions.length) return { ok: false, reason: 'No suggestions returned' };
    const parsed = await resolvePlaceAddress(suggestions[0].placeId);
    return { ok: true, suggestion: suggestions[0].description, parsed };
  } catch (err) {
    return { ok: false, reason: friendlyPlacesError(err), error: String(err?.message || err) };
  }
}

if (typeof window !== 'undefined') {
  window.__mycarslotPlacesSmokeTest = smokeTestGooglePlaces;
}
